import { jwtDecode } from 'jwt-decode';
import React, { useEffect, useState } from 'react';

import subAbas from './subabas';
import BarraInferiorBotoes from '../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../components/BarraSubAbas';
import BoxConteudo from '../../../components/BoxConteudo';
import ContainerConteudo from '../../../components/ContainerConteudo';
import CustomButton from '../../../components/CustomButton';
import CustomCol from '../../../components/CustomCol';
import CustomRow from '../../../components/CustomRow';
import CustomSpan from '../../../components/CustomSpan';
import Input from '../../../components/InputNew';
import Select from '../../../components/InputNew/Select';
import Modal from '../../../components/Modal';
import Tabela from '../../../components/Tabela';
import ToggleSwitch from '../../../components/ToggleSwitch';
import WorkspaceBotoes from '../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../components/WorkspaceFicha';
import BolinhaTabelaStatus from '../../../components/bolinhaTabelaStatus';
import { useModuloUsuario } from '../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../services/enum/usePapelUsuario';
import { useUnidadeDAF } from '../../../services/enum/useUnidadeDaf';
import { getAllUser } from '../../../services/usuario/userService';
import theme from '../../../theme';
import { formatDate } from '../../../utils/functions';
import { valoresExibidosLogsAcoes as valoresExibidos } from '../MeusDados/auxiliarMeusDados';

const HistoricoVinculacoes: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [, setError] = useState<string | null>(null);
  //Enum unidade
  const UnidadeCadastro = useUnidadeDAF();
  //Enum papel
  const papelUsuario = usePapelUsuario();
  //Enum módulo
  const moduloOptions = useModuloUsuario();
  // Estado dos filtros para Nome, Alocação, Papel e etc
  const [formFiltros, setFormFiltros] = useState({
    nome: '',
    unidade: '0',
    papel: '',
    status: null as 'S' | 'N' | null,
  });

  // Define cabeçalhos da tabela
  const headers = [
    { text: '', width: 2, key: '' },
    { text: 'ID', width: 2, key: 'id' },
    { text: 'Status', width: 2, key: 'stRegistroAtivo' }, //Aguardando confirmação de vinculo - cor laranja
    { text: 'Usuário', width: 15, key: 'nomeCompleto' },
    { text: 'Telefone', width: 10, key: 'UnidadeCadastro' },
    { text: 'Email', width: 10, key: 'papel' },
    { text: 'Responsável pela Vinculação', width: 10, key: 'papel' },
    { text: 'Data de Solicitação de Vinculação', width: 10, key: 'papel' },
    { text: 'Data de Vinculação', width: 10, key: 'papel' },
    { text: 'Data de Desvinculação', width: 10, key: 'papel' },
  ];

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');
        if (!token) {
          throw new Error('Token não encontrado.');
        }

        const decodedToken: any = jwtDecode(token);
        const { unidade, papel } = decodedToken;

        const userRole = papelUsuario.find(
          (role) => role.value === papel.toString(),
        );

        if (userRole?.label === 'ADMIN') {
          //  ADMIN
          const userData = await getAllUser();
          setData(userData);
        } else if (userRole?.label === 'REPRESENTANTE TÉCNICO') {
          // RP pega unidade
          const userData = await getAllUser(unidade);
          setData(userData);
        } else {
          setError('Você não tem permissão para visualizar usuários.');
          //console.error('Papel do usuário não permite visualizar usuários.');
        }
      } catch (error) {
        console.error('Erro ao obter dados:', error);
        setError('Ocorreu um erro ao carregar os dados.');
      }
    };

    fetchData();
  }, [papelUsuario]);

  // Atualiza os filtros conforme alteração
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>,
  ) => {
    const { name, value } = e.target;
    setFormFiltros((prev) => ({ ...prev, [name]: value }));
  };

  // Atualiza o filtro de status vindo do ToggleSwitch
  const handleStatusToggle = (newValue: 'S' | 'N') => {
    setFormFiltros((prev) => ({ ...prev, status: newValue }));
  };

  // Limpa os filtros
  const handleClearFiltros = () => {
    setFormFiltros({
      nome: '',
      unidade: '0',
      papel: '',
      status: 'S' as 'S' | 'N' | null,
    });
  };

  // Converte o valor do enum de papel para rótulo
  const getPapelLabel = (valor: any) => {
    const found = papelUsuario.find(
      (role) => role.value.toString() === valor.toString(),
    );
    return found ? found.label : valor;
  };

  // Converte o valor do módulo para seu rótulo
  const getModuloLabel = (valor: any) => {
    const found = moduloOptions.find(
      (option) => option.value.toString() === valor.toString(),
    );
    return found ? found.label : valor;
  };

  // Formata as permissões ativas no formato "NomeModulo: [Operações]"
  const getPermissoesFormatadas = (permissoes: any[]) => {
    if (!permissoes || permissoes.length === 0) return '-';
    return permissoes
      .map((perm) => {
        let ops = '';
        if (perm.create) ops += 'C';
        if (perm.read) ops += 'R';
        if (perm.update) ops += 'U';
        if (perm.delete) ops += 'D';
        return `${getModuloLabel(perm.moduloUsuario)}: ${ops}`;
      })
      .join(', ');
  };

  // Filtra os dados com base nos filtros aplicados
  const filteredData = data.filter((item) => {
    const nomeMatch =
      formFiltros.nome === '' ||
      item.nomeCompleto.toLowerCase().includes(formFiltros.nome.toLowerCase());
    const unidadeMatch =
      formFiltros.unidade === '0' ||
      item.unidadeCadastro === Number(formFiltros.unidade);
    const papelMatch =
      formFiltros.papel === '' || item.papel.toString() === formFiltros.papel;
    const statusMatch =
      formFiltros.status === null ||
      item.stRegistroAtivo === formFiltros.status;

    return nomeMatch && unidadeMatch && papelMatch && statusMatch;
  });

  // Dados da tabela
  const tableData = filteredData.map((item) => ({
    id: item.id,
    stRegistroAtivo: <BolinhaTabelaStatus status={item.stRegistroAtivo} />,
    nomeCompleto: item.nomeCompleto,
    UnidadeCadastro: UnidadeCadastro[item.unidadeCadastro].label,
    papel: getPapelLabel(item.papel) || '-',
    permissoes: getPermissoesFormatadas(item.permissoes),
    dataRegistro: formatDate(item.dataRegistro),
    ultimaAtualizacao: formatDate(item.dataUltimaAtualizacao),
    emailPessoal: item.emailPessoal,
  }));

  // Mapeia os dados para a visualização offcanvas (opcional)
  const offCanvasData = filteredData.map((item) => ({
    id: item.id,
    Status:
      item.stRegistroAtivo === 'S' ? (
        <CustomSpan texto="Ativo" />
      ) : (
        <CustomSpan texto="Inativo" />
      ),
    Usuario: item.nomeCompleto,
    Alocação: UnidadeCadastro[item.unidadeCadastro].label,
    Papel: getPapelLabel(item.papel) || '-',
    Permissões: getPermissoesFormatadas(item.permissoes),
    'Data/Hora': formatDate(item.dataRegistro),
    'Última Atualização': formatDate(item.dataUltimaAtualizacao),
    'Email Pessoal': item.emailPessoal,
  }));

  //Modal para vincular novo usuário

  const [showModalVinculoUsuario, setShowModalVinculoUsuario] =
    useState<boolean>(false);

  const handleShowModalVinculoUsuario = () => {
    setShowModalVinculoUsuario((prev) => !prev);
  };

  return (
    <>
      <BarraSubAbas subAbas={subAbas} />
      <ContainerConteudo>
        <BoxConteudo boxTitulo="Filtros">
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="7%">
              <ToggleSwitch
                label="Status"
                value={formFiltros.status}
                onChange={(newValue) => handleStatusToggle(newValue)}
              />
            </CustomCol>
            <CustomCol width="43%">
              <Input
                id="nome"
                name="nome"
                label="Nome"
                value={formFiltros.nome}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="25%">
              <Select
                name="unidade"
                label="Alocação"
                value={formFiltros.unidade}
                options={UnidadeCadastro}
                onChange={handleChange}
              />
            </CustomCol>
            <CustomCol width="25%">
              <Select
                name="papel"
                label="Papel"
                value={formFiltros.papel}
                options={papelUsuario}
                onChange={handleChange}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080" // Cor cinza
                textColor="#ffffff" // Texto branco
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>
        <Tabela
          headers={headers}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          showPagination={false}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          inserir
          onClickInserir={handleShowModalVinculoUsuario}
        ></WorkspaceBotoes>
      </BarraInferiorBotoes>

      {/* Modal Fase */}
      <Modal
        tituloModal={'Vincular Novo Usuário'}
        open={showModalVinculoUsuario}
        onHide={handleShowModalVinculoUsuario}
      >
        <WorkspaceFicha>
          <CustomRow style={{ marginTop: '10px' }}>
            <CustomCol width="250px">
              <Input
                name="cpf"
                value={''}
                id="numeroFase"
                label="CPF"
                onChange={() => {
                  ('');
                }}
              />
            </CustomCol>
            <CustomCol width="15px"></CustomCol>
            <CustomCol>
              <Input
                name="name"
                value={''}
                id="numeroFase"
                label="Nome"
                onChange={() => {
                  ('');
                }}
                readonly
              />
            </CustomCol>
          </CustomRow>
          <CustomRow>
            <CustomCol style={{ marginTop: '15px', textAlign: 'right' }}>
              <CustomButton
                label="Vincular Usuário"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={() => {
                  ('');
                }}
                disabled
              />
            </CustomCol>
          </CustomRow>
          <BarraInferiorBotoes></BarraInferiorBotoes>
        </WorkspaceFicha>
      </Modal>
    </>
  );
};

export default HistoricoVinculacoes;
